import { render, staticRenderFns } from "./PspTable.vue?vue&type=template&id=59c5225e&scoped=true&"
import script from "./PspTable.vue?vue&type=script&lang=js&"
export * from "./PspTable.vue?vue&type=script&lang=js&"
import style0 from "./PspTable.vue?vue&type=style&index=0&id=59c5225e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c5225e",
  null
  
)

export default component.exports